import { useEffect, useState } from 'react';

const DEFAULTS = { theme: 'paper', density: 'default' };

const THEMES = [
  { k: 'paper', l: 'Paper' },
  { k: 'mono',  l: 'Mono'  },
  { k: 'moss',  l: 'Moss'  },
  { k: 'ink',   l: 'Ink'   },
];

const SPEEDS = [
  { v: 0.5, l: '0.5×' },
  { v: 1,   l: '1×'   },
  { v: 2,   l: '2×'   },
  { v: 4,   l: '4×'   },
  { v: 12,  l: 'Skip' },
];

export function TweaksPanel() {
  const [open, setOpen] = useState(true);
  const [tweaks, setTweaks] = useState(() => {
    try { return JSON.parse(localStorage.getItem('pe-tweaks')) || DEFAULTS; }
    catch { return DEFAULTS; }
  });
  const [surveySpeed, setSurveySpeed] = useState(() => {
    const s = +localStorage.getItem('pe-survey-speed');
    return s > 0 ? s : 4;
  });

  // Apply theme + density to body and persist
  useEffect(() => {
    localStorage.setItem('pe-tweaks', JSON.stringify(tweaks));
    document.body.className = `theme-${tweaks.theme} density-${tweaks.density}`;
  }, [tweaks]);

  const update = (k, v) => setTweaks((prev) => ({ ...prev, [k]: v }));

  const onSpeed = (v) => {
    setSurveySpeed(v);
    localStorage.setItem('pe-survey-speed', String(v));
    window.postMessage({ type: '__pe_survey_speed', value: v }, '*');
  };

  const onResetSurvey = () => window.postMessage({ type: '__pe_survey_reset' }, '*');

  if (!open) return null;

  return (
    <div className="tweaks">
      <div className="tweak-head">
        <span>Tweaks</span>
        <button onClick={() => setOpen(false)} style={{ color: 'inherit' }}>×</button>
      </div>
      <div className="tweak-body">
        <div className="tweak-row">
          <label>Theme</label>
          <div className="seg">
            {THEMES.map((o) => (
              <button key={o.k} aria-selected={tweaks.theme === o.k} onClick={() => update('theme', o.k)}>
                {o.l}
              </button>
            ))}
          </div>
        </div>
        <div className="tweak-row">
          <label>Density</label>
          <div className="seg">
            {['default', 'cozy', 'compact'].map((d) => (
              <button key={d} aria-selected={tweaks.density === d} onClick={() => update('density', d)}>
                {d}
              </button>
            ))}
          </div>
        </div>
        <div className="tweak-row">
          <label>Survey speed</label>
          <div className="seg">
            {SPEEDS.map((o) => (
              <button key={o.v} aria-selected={surveySpeed === o.v} onClick={() => onSpeed(o.v)}>
                {o.l}
              </button>
            ))}
          </div>
        </div>
        <div className="tweak-row">
          <label>Survey</label>
          <button
            onClick={onResetSurvey}
            className="mono"
            style={{
              fontSize: 11, letterSpacing: '0.06em', textTransform: 'uppercase',
              padding: '5px 10px', border: '1px solid var(--ink)', background: 'var(--paper)',
              cursor: 'pointer',
            }}
          >
            ↺ Reset simulation
          </button>
        </div>
        <div className="tweak-row">
          <label>Tip</label>
          <div style={{ fontSize: 11, color: 'var(--ink-3)', lineHeight: 1.4 }}>
            Open <em>Brand Builder</em> → <em>Run new survey</em> to start the flow. Esc closes.
          </div>
        </div>
      </div>
    </div>
  );
}

export default TweaksPanel;
